export const envName = process.env.REACT_APP_ENV_NAME;
